"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var useStyles = exports.useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      display: 'inline-block',
      padding: '0px 9px',
      height: 17,
      lineHeight: '17px',
      minWidth: 25,
      textAlign: 'center',
      borderRadius: '45px',
      verticalAlign: 'middle',
      fontSize: 11,
      fontWeight: theme.typography.fontWeightMedium,
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
      backgroundColor: '#e0e0e0'
    },
    clickable: {
      cursor: 'pointer'
    },
    primary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    secondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    success: {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.contrastText
    },
    error: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },
    warning: {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.warning.contrastText
    },
    neutral: {
      backgroundColor: theme.palette.neutral.main,
      color: theme.palette.neutral.contrastText
    }
  };
});

/**
 * HiPins
 *
 * Tiny contained button used to display subsidiary datas like item count, (...), and throw an onClick event.
 * Used in:
 * - CellStatus to display operations count and to deploy operation rows on click.
 *
 */
function HiPin(props) {
  var children = props.children,
    color = props.color,
    onClick = props.onClick,
    className = props.className;
  var classes = useStyles(props);
  var pinClass = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.clickable, onClick), classes.primary, color === 'primary'), classes.secondary, color === 'secondary'), classes.success, color === 'success'), classes.error, color === 'error'), classes.warning, color === 'warning'), classes.neutral, color === 'neutral'), className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: pinClass,
    onClick: onClick,
    role: onClick ? 'button' : undefined
  }, children);
}
HiPin.defaultProps = {
  color: 'default'
};
HiPin.useStyles = useStyles;
var _default = exports.default = HiPin;